import style from './index.module.scss'
import React, { useContext, useState } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { GlobalContext, useAuth, useGlobalParams } from '@/entities'
import { RootState, useAppDispatch } from '@/store'
import { useTranslations } from 'use-intl'
import { LogoutDialog } from '@/features'
import { setCurrentSubAccount, setDialogs } from '@/store/sub_accounts'
import { LOGOUT_DIALOG } from '@/entities/cabinet'
import { useSelector } from 'react-redux'
import Logo from '@/shared/ui/Logo'

export function MainHeader() {
    const navigate = useNavigate()
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const { currentUser } = useGlobalParams()
    const { pathname } = useLocation()
    const { logout } = useAuth()
    const dispatch = useAppDispatch()
    const { setCurrentUser, setIsLogged } = useContext(GlobalContext)
    const i18n = useTranslations('header')
    const dialogs = useSelector((state: RootState) => state.subAccount.dialogs)

    return (
        <>
            <header className={style.main__header}>
                <div className="container">
                    <div className={style.main__header__content}>
                        <button
                            className={style.main__header__burger}
                            onClick={() => setIsMobileMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <Link to={'/'}>
                            <Logo dark={true} />
                        </Link>
                        <nav className={style.main__header__nav}>
                            <Link to="https://frontech.om/about">About Us</Link>
                            <Link to="/terms-in-use">Terms of Use</Link>
                            <Link to="/policy">Privacy Policy</Link>
                            <Link to="/faq">Support</Link>
                        </nav>
                        <div className={style.main__header__buttons}>
                            {currentUser ? (
                                <>
                                    <div
                                        className={classNames(
                                            'logined-user-box'
                                        )}
                                        onClick={() => {
                                            if (!pathname.includes('cabinet')) {
                                                navigate('/cabinet')
                                            }
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="abs-link jsXsOpenSidebarBtn"
                                        />
                                        <div className="ava no-ava"></div>
                                        <div className="user-desc">
                                            <span className="user-label"></span>
                                            <div className="user-name">
                                                <span>
                                                    {currentUser?.user.username}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <img
                                        src={
                                            require('@/shared/images/svg/logout.svg')
                                                .default
                                        }
                                        style={{
                                            marginLeft: '10px',
                                            cursor: 'pointer',
                                        }}
                                        alt="logout"
                                        onClick={() => {
                                            logout().then(() => {
                                                setCurrentUser(null)
                                                setIsLogged(false)
                                                dispatch(
                                                    setDialogs({
                                                        key: LOGOUT_DIALOG,
                                                        value: false,
                                                    })
                                                )
                                                dispatch(
                                                    setCurrentSubAccount('')
                                                )
                                                window.location.reload()
                                            })
                                        }}
                                    />
                                </>
                            ) : (
                                <>
                                    <button
                                        className={style.main__header__button}
                                        onClick={() => navigate('/auth/signup')}
                                    >
                                        Sign Up
                                    </button>
                                    <button
                                        className={style.main__header__button}
                                        onClick={() => navigate('/auth/login')}
                                    >
                                        Login
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </header>

            {/* Mobile Menu Modal */}
            {isMobileMenuOpen && (
                <div
                    className={style.main__mobile__menu}
                    onClick={() => setIsMobileMenuOpen(false)}
                >
                    <div
                        className={style.main__mobile__menu__content}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={style.main__mobile__menu__close}
                            onClick={() => setIsMobileMenuOpen(false)}
                            aria-label="Close menu"
                        >
                            ×
                        </button>
                        <nav className={style.main__mobile__menu__nav}>
                            <Link
                                to="/#about"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                About Us
                            </Link>
                            <Link
                                to="/terms-in-use"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Terms of Use
                            </Link>
                            <Link
                                to="/policy"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                to="/faq"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Support
                            </Link>
                        </nav>
                        <div className={style.main__mobile__menu__buttons}>
                            <button
                                className={style.main__mobile__menu__button}
                                onClick={() => {
                                    setIsMobileMenuOpen(false)
                                    navigate('/auth/signup')
                                }}
                            >
                                Sign Up
                            </button>
                            <button
                                className={style.main__mobile__menu__button}
                                onClick={() => {
                                    setIsMobileMenuOpen(false)
                                    navigate('/auth/login')
                                }}
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {dialogs[LOGOUT_DIALOG] && <LogoutDialog />}
        </>
    )
}
